export default "__VITE_ASSET__YVrccQYb__"